// This file is autogenerated. Any changes will be overwritten.
export const name = 'undock';

export const Component = () => (
  <path d='m11.4923882 13.5c.3905242.3905243.3905242 1.0236893 0 1.4142136l-5.0863882 5.0857864h4.094c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-7.5v-7.5c0-.5522847.44771525-1 1-1s1 .4477153 1 1v4.078l5.0781746-5.078c.3905243-.3905243 1.0236893-.3905243 1.4142136 0zm10.5076118-10.5v7.5c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-4.18l-5.1789322 5.18c-.3905243.3905243-1.0236893.3905243-1.4142136 0-.3905242-.3905243-.3905242-1.0236893 0-1.4142136l5.0851458-5.0857864h-3.992c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1z' />
);

export const viewBox = '0 0 25 25';
